module.exports = __webpack_public_path__ + "img/icon_tt_bul_selected_on02.8ddbbb8a.svg";